import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

function NotFound() {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate("/");
    }

    return (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center pb-lg-5">
            <div className="text-center p-3 p-md-5">
                <h1 className="display-1 fw-bold text-primary opacity-50">404</h1>
                <div className="h5">Page Not Found</div>
                <Button
                    variant="primary"
                    size="lg"
                    className="mt-5 px-4"
                    onClick={goToHome}>
                    Go to Home
                </Button>
            </div>
        </div>
    );
}

export default NotFound;
